import { useCallback } from "react";
import { ViewerLinkApi, useAPIAction } from "melco-shared-logic";

export interface LoginInterface {
  id: string;
  melcoMachineStatisticsModelsUpdateGroup: {
    name: string;
    machine_list: [];
  };
}

export const useLogin = () => {
  const [Login] = useAPIAction(
    ViewerLinkApi,
    async (api: ViewerLinkApi, LoginDetails: any) => {
      const { view_id, password, access_token } = LoginDetails;

      let data = await api.statisticalViewerLinkAuth({
        id: view_id,
        reportingMelcoMachineStatisticsModelsAuthViewerLink: {
          access_token: access_token,
          password: password,
        },
      });

      return {
        data,
        successMessages: [],
      };
    },
    {
      skipErrorHandling: true,
      translationPrefix: "",
    }
  );

  return useCallback(
    async (LoginDetails: any) => {
      return await Login(LoginDetails);
    },
    [Login]
  );
};
